import { render, staticRenderFns } from "./FinderFrame.vue?vue&type=template&id=617167b2"
import script from "./FinderFrame.vue?vue&type=script&lang=js"
export * from "./FinderFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports